import './styles.scss';

/**
 * Phone component renders a phone mockup for the hero section.
 * It always shows a localized thumbnail image, and if a video URL is provided,
 * it overlays and autoplay-loops the muted video inside the mockup.
 *
 * When videoSlotRef is provided (shared video), only the slot div is rendered;
 * the actual video node is moved here by LandingVideoProvider.
 *
 * @param {string} [videoUrl] — Optional video URL to display inside the phone mockup.
 * @param {React.RefObject} [videoSlotRef] — Optional ref for shared video slot (used with LandingVideoProvider).
 * @param {string} image — Image URL to display inside the phone mockup.
 * @param {string} alt — Alt text for the icon.
 * @param {string} [className] — Optional additional CSS class for the root container.
 */

export const Phone = ({ videoUrl, videoSlotRef, image, alt, className }) => {
    const useSharedSlot = Boolean(videoSlotRef);

    return (
        <div className={`phone ${className || ''}`}>
            <img
                alt={alt}
                src={image}
                width='1080'
                height='1920'
                className='phone__image'
            />

            {useSharedSlot && (
                <div ref={videoSlotRef} className='phone__video' />
            )}

            {!useSharedSlot && videoUrl && (
                <div className='phone__video'>
                    <video
                        src={videoUrl}
                        poster={image}
                        playsInline
                        autoPlay
                        muted
                        loop
                        preload='metadata'
                    />
                </div>
            )}
        </div>
    );
};
